import z from "zod";
import { DOC_CATEGORY } from "../constants";

// TODO: add other fields as bid is worked through
export const schema = z
  .object({
    name: z.string().min(1, "Bid name is required"),
    builderId: z.string().min(1, "Customer is required"),
    communityId: z.string().min(1, "Community is required"),
    dueDate: z.string().min(1, "Due date is required"),
    additionalFeatures: z.string().min(1, "Additional features is required"),
    pipeBrand: z.string().optional(),
    documents: z.array(
      z.object({
        category: z.string().optional(),
      })
    ),
    planAreas: z.array(
      z.object({
        floorId: z.string(),
        areaTypeId: z.string().optional(),
        label: z.string().optional(),
        specColumn: z.number().optional(),
        areaTypeName: z.string().optional(),
        displayOrder: z.number().optional(),
        materials: z
          .array(
            z.object({
              materialId: z.string(),
              suppliedByBuilder: z.boolean().optional(),
              quantity: z.number().optional(),
            })
          )
          .optional(),
      })
    ),
  })
  .refine(
    (data) => data.documents.some((d) => d.category === DOC_CATEGORY.PLAN),
    { message: "Plan file is required", path: ["documents"] }
  )
  .refine(
    (data) => data.documents.some((d) => d.category === DOC_CATEGORY.SPEC),
    { message: "Spec file is required", path: ["documents"] }
  );
